import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";

export const ProfessionalPaymentInfosSkeleton = () => {
  return (
    <Box className="card text-body bg-light p-3 px-md-5 py-md-4 sticky-xl-top">
      <Skeleton variant="text" width={"100%"} />
      <Skeleton variant="text" width={"100%"} />
      <Box className="bg-white rounded-4 border p-3 pb-0 mb-4">
        <Box className="row align-items-center">
          <Box className="col col-auto pb-3 e-0">
            <Skeleton variant="circular" width={60} height={60} />
          </Box>

          <Box className="col-12 col-sm pb-3">
            <Skeleton variant="text" width={"60%"} />
            <Skeleton variant="text" width={"60%"} />
            <Skeleton variant="text" width={"60%"} />
          </Box>
        </Box>
      </Box>

      <Skeleton variant="text" width={100} />
      <Box
        style={{ height: 60 }}
        className="bg-white rounded-4 border p-3 mb-4"
      />

      <Skeleton variant="text" width={100} />
      <Box
        style={{ height: 60 }}
        className="bg-white rounded-4 border p-3 mb-4"
      />

      <Box
        className="text-center"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Skeleton variant="rectangular" width={250} height={40} />
      </Box>
    </Box>
  );
};
